import { render } from "./ListaSinistrosAcordoView.vue?vue&type=template&id=d4982590&scoped=true"
import script from "./ListaSinistrosAcordoView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosAcordoView.vue?vue&type=script&lang=js"

import "./ListaSinistrosAcordoView.vue?vue&type=style&index=0&id=d4982590&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4982590"]])

export default __exports__